import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/dist/query/react";
import { handlingErrorResponse } from "utils/HandlingErrorResponse";
import { RootState } from "store/store";
import { getAuthToken } from "utils/getAuthToken";
import { baseUrl } from "constant";
import { IGetOverTimeListRequest, IGetOverTimeListResponse, IApprovedDeclinedOvertime, IOverTimeType } from "../types";
import { EmployeeOvertimeEndpointConst, deleteOverTime, getCurrentOverTime, getEmployeeInfoByCodeUrl, getOverTimeListByCode } from "./const";
import {
    IEmployeeDetailsTypeResponse, IEmployeeDetailsRequestType, IGetCurrentOverTimeResponseType,
    IGetCurrentOverTimeRequestType
} from "./type"

export const OverTimeApi = createApi({
    reducerPath: 'overTimeApi',
    baseQuery: fetchBaseQuery({
        baseUrl: baseUrl,
        prepareHeaders: (headers, { getState }) => {
            const token = getAuthToken(getState() as RootState)
            if (token) {
                headers.set('Authorization', `Bearer ${token}`)
            }
            return headers
        },
    }),
    tagTypes: ['OverTime'],
    endpoints: (builder) => ({
        OverTimeList: builder.mutation<IGetOverTimeListResponse, IGetOverTimeListRequest>({
            query: userReq => ({
                url: EmployeeOvertimeEndpointConst.overTimeList,
                method: 'POST',
                body: userReq.overTimeFilter
            }),
            transformErrorResponse: handlingErrorResponse,
            invalidatesTags: [{ type: 'OverTime', id: 'OverTimeList' }],
        }),
        AddOverTime: builder.mutation<void, IOverTimeType>({
            query: userReq => ({
                url: EmployeeOvertimeEndpointConst.AddUpdateOverTime,
                method: 'POST',
                body: userReq
            }),
            transformErrorResponse: handlingErrorResponse,
            invalidatesTags: [{ type: 'OverTime', id: 'OverTimeList' }],
        }),
        GetEmployeeByCode: builder.query<IEmployeeDetailsTypeResponse, IEmployeeDetailsRequestType>({
            query: (params) => getEmployeeInfoByCodeUrl(params),
            transformErrorResponse: handlingErrorResponse,
            providesTags: [{ type: 'OverTime', id: 'OverTime' }]
        }),
        DeleteOverTime: builder.mutation<void, number>({
            query: overTimeId => ({
                url: deleteOverTime(overTimeId),
                method: 'DELETE',
            }),
            transformErrorResponse: handlingErrorResponse,
            invalidatesTags: [{ type: 'OverTime', id: 'OverTimeList' }],
        }),
        GetCurrentOverTime: builder.query<IGetCurrentOverTimeResponseType, IGetCurrentOverTimeRequestType>({
            query: (params) => getCurrentOverTime(params),
            transformErrorResponse: handlingErrorResponse,
            providesTags: [{ type: 'OverTime', id: 'OverTimeList' }]
        }),
        AddOverTimestatus: builder.mutation<void, IApprovedDeclinedOvertime>({
            query: userReq => ({
                url: EmployeeOvertimeEndpointConst.AddOverTimeStatus,
                method: 'PUT',
                body: userReq
            }),
            transformErrorResponse: handlingErrorResponse,
            invalidatesTags: [{ type: 'OverTime', id: 'OverTimeList' }],
        }),
        GetOverTimeByCodeList: builder.mutation<IGetOverTimeListResponse, IGetOverTimeListRequest>({
            query: userReq => ({
                url: getOverTimeListByCode(userReq),
                method: 'POST',
                body: userReq.overTimeFilter
            }),
            transformErrorResponse: handlingErrorResponse,
            invalidatesTags: [{ type: 'OverTime', id: 'OverTimeList' }],
        }),
    }),
})
